/* eslint-disable global-require */
import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';
import GebietskarteNetzbetrieb from 'assets/pdf/GebietskarteNetzbetrieb.pdf';
import GebietskarteProjektierung from 'assets/pdf/GebietskarteProjektierung.pdf';

import { BulletList } from 'components/ExpertSearch/components/BulletList/BulletList';
import { MailHotline } from 'components/ExpertSearch/components/MailHotline/MailHotline';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

import './BetriebsstellenProjektierung.scss';

export const BetriebsstellenProjektierung = () => {
  return (
    <div className="expert-page betriebsstellen-projektierung">
      <div className="expert-page-content-stage-text">
        <PageTitleSection title="Dezentraler Netzbetrieb (Betriebsstellen)" notFramed />
        <MailHotline>
          <p>
            Postfach: siehe Gebietskarte oder unter{' '}
            <a href="https://www.lew-verteilnetz.de/lew-verteilnetz/ueber-lew-verteilnetz/kontakt">
              Kontakt LVN
            </a>
          </p>

          <p>
            Hotline: 0821/328-2222 über PLZ-Routing an die Kollegen vom dezentralen Netzbetrieb
            (Betriebsstellen)
          </p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>Störungsbehebung im Verteilnetz</li>
              <li>Ausführung von Netzmaßnahmen</li>
              <li>Netzfreischaltungen im 1-kV und 20-kV-Netz</li>
              <li>
                Leistungen am Dachständer (Freileitungsisolierungen, Versetzung, Verstärkung oder
                Wiederanbringung)
              </li>
              <li>Leistungen für Demontage des Netzanschlusses</li>
              <li>vorübergehender Netzanschluss (Baustrom, Festplatzanschlüsse)</li>
              <li>Erstellen von Netzanschlüssen</li>
              <ul>
                <li>Standard-Netzanschlüsse oder Anschlussänderungen bis 150kW</li>
                <li>
                  Standard-Netzanschlüsse innerhalb geschlossener Ortschaften mit einer max. Länge
                  von 100m (davon maximal 25m auf öffentlichem Grund)
                </li>
                <ul>
                  <li>
                    Vom Standard abweichende Netzanschlüsse werden durch die Abteilung Projektierung
                    (siehe Gebietskarte Projektierung) individuell kalkuliert. Hierzu zählen auch
                    überdurchschnittliche Mehraufwände wie z. B.: Tiefbau-Mehraufwand, schwierige
                    Bodenverhältnisse, besondere Oberflächenwiederherstellung
                  </li>
                </ul>
              </ul>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht zum dezentralen Netzbetrieb"
          items={
            <>
              <li>Zähler Themen ausgenommen Baustrom</li>
              <li>Einspeiser Themen</li>
              <li>Abrechnungs Themen</li>
              <li>Abfrage der vertraglich vereinbarten Leistung</li>
              <li>
                Grundsatzfragen (Netzform, Abstimmungen zu Messkonzepten, Umbauten, Erweiterungen)
              </li>
              <li>Fragen zur Systemlandschaft iConnect</li>
              <li>Melo / Malo Messlokationen</li>
            </>
          }
        />
        <PageTitleSection title="Gebietskarten" notFramed />
        <div className="betriebsstellen-projektierung__map-flex">
          <div className="betriebsstellen-projektierung__map-flex__height-container">
            <object
              data={GebietskarteNetzbetrieb}
              height="100%"
              width="100%"
              type="application/pdf">
              <p>Konnte Gebietskarte-Netzbetrieb nicht laden</p>
            </object>
          </div>
          <div className="betriebsstellen-projektierung__map-flex__height-container">
            <object
              data={GebietskarteProjektierung}
              height="100%"
              width="100%"
              type="application/pdf">
              <p>Konnte Gebietskarte-Projektierung nicht laden</p>
            </object>
          </div>
        </div>
      </div>
    </div>
  );
};
MapTo('e-fix/components/content/betriebsstellenprojektierung')(BetriebsstellenProjektierung);
